import { Injector, TemplateRef } from '@angular/core';

export type PrizmDateButton = {
  template: TemplateRef<unknown>;
};
export type PrizmDateButtonContext = {
  injector: Injector;
};
